import { BaseModel } from '@fry/lib/store';
import { EasBuilderForm } from '@fry/components/common/form-builder/builder.interfaces';

interface StatsSummary {
  count: number;
  balanceReal: number;
  balancePending: number;
  balanceCancelled: number;
  receivedReal: number;
  receivedPending: number;
  refundedReal: number;
  refundedPending: number;
}

interface StatsState {
  id: string;
  title: string;
  summary: StatsSummary;
}

export interface BookingOptionDoc {
  _id: string; // How the hell do this?
  id: string;
  title: string;
  breadcrumbs: {
    id: string;
    title: string;
  };
  bookingDates: {
    startDate: string;
    endDate: string;
  };
  bookingWindow: {
    startDate: string;
    endDate: string;
  };
  capacities: any;
  eligibility: {
    id: string;
    rules: string;
  };
  eligibilityResult?: {
    overall: boolean;
    reason: string;
    reasonVerbose: string;
  };
  form: EasBuilderForm;
  venue: any;
  bookingAllowed: boolean;
  bookableType: 'cover' | 'bookable' | 'hidden';
  bookingItem: {
    _id: string;
    bookingType: string;
    name: string;
    state: string;
  };
  used_capacity: {
    available: number;
    free: number;
    all?: number;
    in_progress?: number;
    confirmed?: number;
    expired?: number;
  };
  pricing: {
    price: string;
    currency: string;
    externalCode: string;
    method: string;
  };
  state: {
    id: string;
    name: string;
  };
  summary: {
    bookingDates: { min: string; max: string };
    bookingWindow: { min: string; max: string };
    price: { min: string; max: string; currency: string };
    openOptions: number;
    eligible: boolean;
  };
  stats: {
    id: string;
    title: string;
    states: StatsState[];
    summary: StatsSummary;
  };
}


export class BookingOption extends BaseModel {

}
